import BaseTreeNode from './BaseTreeNode'
import WeaverService from 'Services/WeaverService'
import * as Types from 'Types'
import { ActionsPage } from 'Model'
import Feather from '@sysunite/react-feather'
import { Modal } from 'antd'
import { ContextMenu, showActionsPage } from 'Components'
import { getNodeLabel, getUid } from 'Services/WeaverUtils'
import { store } from '~/Store'
import { createRoot, ComplexLabel, createNewItem, editDeleteCtxMenu, getIcon, getIds } from './shared'
import { deleteAction } from 'Actions/homeTree'

actionsRootTitle = (
  <ComplexLabel
    title="Services"
    url={"settings/services/new"}
    testId="create-action"
  />
)

getActions = (props) ->
  actions = await ActionsPage.list()
  sorted = _.sortBy(actions, (action) -> action.get('name')?.toLowerCase())
  if actions.length is 0 then [createAction] else sorted.map((a) -> actionTreeNode(a, props))

export actionsRoot = createRoot(actionsRootTitle, Types.ACTIONS, 'all_actions', getActions, Types.USERMODES.ADVANCED, true)

export createAction = createNewItem('all_actions', 'action', Types.CREATE_ACTION)

export actionTreeNode = (action, props) ->
  {
    node: action
    key: action.id()
    path: "all_actions/#{action.id()}"
    type: Types.ACTION
    isLeaf: true
    selectable: true
    title: (
      <ContextMenu actions={actionCtxMenu(props, action)}>
        <BaseTreeNode
          testId="action-#{action.get('title')}"
          label={action.get('title')}
        />
      </ContextMenu>
    )
  }

actionCtxMenu = editDeleteCtxMenu(
  'action',
  (props, node, { domEvent }) ->
    domEvent.stopPropagation()
    props.history.push("/#{ props.spaceId }/settings/services/#{ node.id() }")
  , (props, node) ->
    store.dispatch(deleteAction(node.id()))
    await node.destroy()
)

export default {
  [Types.CREATE_ACTION]: (node, { history, spaceId }) ->
    history.push("/#{ spaceId }/settings/services/new")
  [Types.ACTION]: ({ node }) ->
    actPage = node.toPlainObj()
    showActionsPage(actPage)
}
